<div class="notifications-page">
	<mat-card>
		<mat-card-title>
			Alerts & Notifications
		</mat-card-title>
		<mat-card-content>
			<div fxLayout fxLayoutAlign="start center" class="mb-2 ml-2 mt-xs">
				<mat-form-field fxFlex="90%" class="mr-1">
					<input class="filter-box" matInput type="text" placeholder="Filter by Message content"
						[(ngModel)]="filterText" (keyup)="applyFilter()" />
				</mat-form-field>
			</div>

			<table mat-table [dataSource]="notifications" class="trip-table">
				<ng-container matColumnDef="lastOccurrenceDate">
					<th mat-header-cell *matHeaderCellDef><strong>Date Last Occurred</strong></th>
					<td mat-cell *matCellDef="let element">
						<a *ngIf="element.uniqueIdentifier.startsWith('DATAIMPORT')" class="timesheet-link"
							[routerLink]="['/pilotpay/notifications/audit-log', element.uniqueIdentifier]"
							[queryParams]="{ date: element.createdDate }">{{ element.lastOccurrenceDate | date:
							'MM/dd/yy hh:mm' }}</a>
						<span *ngIf="!element.uniqueIdentifier.startsWith('DATAIMPORT')">
							{{ element.lastOccurrenceDate | date: 'MM/dd/yy hh:mm' }}
						</span>
					</td>
				</ng-container>

				<ng-container matColumnDef="createdDate">
					<th mat-header-cell *matHeaderCellDef><strong>First Occurred</strong></th>
					<td mat-cell *matCellDef="let element">{{ element.createdDate }}</td>
				</ng-container>

				<ng-container matColumnDef="occurrenceCount">
					<th mat-header-cell *matHeaderCellDef><strong>Occurrences</strong></th>
					<td mat-cell *matCellDef="let element">{{ element.occurrenceCount }}</td>
				</ng-container>

				<ng-container matColumnDef="type">
					<th mat-header-cell *matHeaderCellDef><strong>Source</strong></th>
					<td mat-cell *matCellDef="let element">{{ element.type }}</td>
				</ng-container>

				<ng-container matColumnDef="message">
					<th mat-header-cell *matHeaderCellDef><strong>Message</strong></th>
					<td mat-cell *matCellDef="let element">
						<span *ngIf="!element.uniqueIdentifier?.startsWith('DATAIMPORT')"
							[innerHTML]="formatMessage(element.message, element.uniqueIdentifier, element.createdDate)">
						</span>

						<span *ngIf="element.uniqueIdentifier?.startsWith('DATAIMPORT')">
							{{ getMessageWithoutLink(element.message) }}
							<a *ngIf="element.message.includes('available here')"
								(click)="anchorClick(element.uniqueIdentifier, element.createdDate)"
								style="color:#007ad9;">
								available here.
							</a>
						</span>
					</td>
				</ng-container>

				<tr class="pilots-table-header" mat-header-row *matHeaderRowDef="displayedColumns"></tr>
				<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
			</table>

			<mat-paginator #paginator (page)="handlePageChanged($event)" [pageSizeOptions]="[20, 50, 100]"
				showFirstLastButtons></mat-paginator>
		</mat-card-content>
	</mat-card>
</div>